import React from 'react';
import NFTUserAvatar from '../../../components/NFTUserAvatar';
import { HeaderBottom, HeaderBottomTabItem, HeaderContent, HeaderProfileImage, HeaderSocial, HeaderSocialItem, HeaderSocialItemNavLink, HeaderUserInfo, ProfileHeaderWrapper, UserTitle } from './styled';
import { ReactComponent as VerifiedIcon } from '../../../../../assets/svg/verified.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faExternalLink, faUserEdit } from "@fortawesome/free-solid-svg-icons";
import { useParams } from 'react-router-dom';
import { useWeb3React } from '@web3-react/core';
import useNFTUserData from '../../../data/useNFTUserData';
import { getWalletAddress } from '../../../utils/NFTFormatedData';
import { ITabItem } from '../../../newComponents/NFTTabs';
import cx from '../../../../../utils/cx';

interface IProfileHeaderProps {
    activeTab?: string;
    onTabChange?: (tab: string) => void;
}

export const profileTabItems: ITabItem[] = [
    {
        key: "on-sale",
        name: "On Sale"
    },
    {
        key: "collection",
        name: "Collection"
    },
    {
        key: "activity",
        name: "Activity"
    }
];

const ProfileHeader = (props: IProfileHeaderProps) => {
    const { account } = useWeb3React()
    const { accountParam } = useParams<{ accountParam: string }>()
    const userAccount = accountParam || account || ''

    const { userData } = useNFTUserData(userAccount ?? "wallet");

    const isOwnProfile = userAccount === account;
    const notSignedIn = !account && !accountParam;

    const renderSocialLinks = React.useMemo(() => {
        if (notSignedIn) {
            return null;
        } else {
            return (
                <HeaderSocial>
                    {userData?.twitterUrl &&
                        <HeaderSocialItem href={userData.twitterUrl} title={userData.twitterUrl} target="_blank">
                            <FontAwesomeIcon icon={faTwitter} />
                        </HeaderSocialItem>
                    }
                    {userData?.instagramUrl &&
                        <HeaderSocialItem href={userData.instagramUrl} title={userData.instagramUrl} target="_blank">
                            <FontAwesomeIcon icon={faInstagram} />
                        </HeaderSocialItem>
                    }
                    {userData?.websiteUrl &&
                        <HeaderSocialItem href={userData.websiteUrl} title={userData.websiteUrl} target="_blank">
                            <FontAwesomeIcon icon={faExternalLink} />
                        </HeaderSocialItem>
                    }
                </HeaderSocial>
            )
        }

    }, [userData, notSignedIn]);

    const onTabChange = (tab: string) => {
        props.onTabChange?.(tab);
    };

    return (
        <ProfileHeaderWrapper>
            <HeaderContent>
                <HeaderProfileImage>
                    <NFTUserAvatar accountAddress={notSignedIn ? "notSignedIn" : userAccount} profileImgUrl={userData?.profileImgUrl} height={150} width={150} />
                </HeaderProfileImage>
                <HeaderUserInfo>
                    <UserTitle>
                        {isOwnProfile &&
                            <HeaderSocialItemNavLink to="/account-details">
                                <FontAwesomeIcon icon={faUserEdit} size={"1x"} />
                                <span>Edit Profile</span>
                            </HeaderSocialItemNavLink>
                        }
                        {userData?.isVerified && <VerifiedIcon />}
                        {(userData?.username ?? getWalletAddress(userAccount, 6)) || "Unknown User"}
                    </UserTitle>
                    {userData?.bio && <span>{userData.bio}</span>}
                    {notSignedIn && <span>You can connect your wallet to see your own profile</span>}
                </HeaderUserInfo>
                {renderSocialLinks}
            </HeaderContent>
            <HeaderBottom>
                {profileTabItems.map(item => (<HeaderBottomTabItem key={item.key} onClick={() => { onTabChange(item.key) }} className={cx({ active: props.activeTab === item.key })}>{item.name}</HeaderBottomTabItem>))}
            </HeaderBottom>
        </ProfileHeaderWrapper>
    )
}
export default React.memo(ProfileHeader);